import { message, notification } from 'antd';

// Configure notification placement
notification.config({ placement: 'bottomRight', duration: 5 });

export const feedbackSuccess = (action: string, emailSent?: boolean, emailNote?: string) => {
  message.success(`${action} successfully`);
  if (emailSent === true) {
    notification.success({
      message: '✅ Email Notification Sent',
      description: emailNote || 'Employee has been notified via email.',
    });
  } else if (emailSent === false) {
    notification.warning({
      message: '⚠️ Action Completed',
      description: emailNote || 'Action completed but email notification could not be sent.',
      duration: 7,
    });
  }
};

export const feedbackError = (action: string, error?: string) => {
  message.error(`${action} failed${error ? ': ' + error : ''}`);
};

export const feedbackEmail = (sent: boolean, note?: string) => {
  if (sent) {
    notification.success({
      message: '📧 Email Sent',
      description: note || 'Employee notified successfully.',
    });
  } else {
    notification.warning({
      message: '📧 Email Not Sent',
      description: note || 'Could not send email notification.',
      duration: 7,
    });
  }
};
